import axios from "axios";

const apiClient = axios.create({
  baseURL: "/api",
  timeout: 15000,
  headers: { "Content-Type": "application/json" },
});

function generateRequestID(): string {
  try {
    const buf = new Uint8Array(16);
    crypto.getRandomValues(buf);
    return Array.from(buf)
      .map((b) => b.toString(16).padStart(2, "0"))
      .join("");
  } catch {
    return Math.random().toString(36).slice(2) + Date.now().toString(36);
  }
}

apiClient.interceptors.request.use((config) => {
  const rid = generateRequestID();
  config.headers["X-Request-ID"] = rid;
  (config as any).__requestId = rid;
  return config;
});

apiClient.interceptors.response.use(
  (response) => {
    const serverRid =
      response.headers["x-request-id"] ||
      response.headers["X-Request-ID"] ||
      response.headers["X-Trace-ID"];
    const clientRid = (response.config as any).__requestId;
    const traceId = serverRid || clientRid;
    if (traceId) {
      (response.config as any).__requestId = traceId;
      (response as any).__requestId = traceId;
    }
    return response;
  },
  (error) => {
    const status = error.response?.status;
    const path = window.location.pathname;
    if (status === 401) {
      if (path !== "/login" && path !== "/setup") {
        window.location.href = "/login";
      }
    }
    if (status === 503) {
      if (path !== "/setup" && path !== "/login") {
        window.location.href = "/setup";
      }
    }
    return Promise.reject(error);
  },
);

export function getRequestID(error: unknown): string {
  if (
    typeof error === "object" &&
    error !== null &&
    "config" in error &&
    typeof (error as any).config === "object" &&
    (error as any).config !== null
  ) {
    return ((error as any).config as any).__requestId || "";
  }
  return "";
}

export default apiClient;
